const DUSection: React.FC = () => {
    return (
        <>
        </>
    );
}
export default DUSection;
